/**
 * LangServer API 클라이언트
 */
import axios from 'axios';

import { LANGSERVER_CONFIG } from './config';

export const langServerClient = axios.create({
  baseURL: LANGSERVER_CONFIG.BASE_URL,
  timeout: LANGSERVER_CONFIG.TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
    accept: 'application/json',
  },
});
